import React from "react";
import { connect } from "react-redux";

import { movil } from "../app-movil";
import { goTo } from "../tools";

import Modal from '../generalcomponets/modal-mobile';


const mapState = (state) => {
	return {
		loading: state.global.loading,
		email: state.registro.email,
		password: state.registro.password,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		enviarLogin: (oMensaje) => {
			dispatch({ "type": "ENVIAR_MENSAJE_MOVIL", "mensaje": oMensaje});
		},
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Bienvenido extends React.Component {

	state = {
		isModalOpened: false
	}

	enviarLogin = () => {
		if (this.props.dispositivo === 'app')
			this.closeModalFromChild();
		
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_REGISTRO_FINALIZADO-INICIAR-SESION", "dispositivo": this.props.dispositivo });
		
		let mensaje = {"email": this.props.email, "password": this.props.password, "return": "autologin"};
		movil("registro", mensaje);
		
		this.props.limpiarRegistro();
		goTo("login");
	}

	openModalParent = (type, title, message) => {
		let { isModalOpened } = this.state;

		if(isModalOpened)
		  this.setState({ isModalOpened: false})
		else{
		  this.setState({ isModalOpened: true});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false});
	}
	
	render() {
		return (
			<div>
				<div className='text-content no-margin'>
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<h3>Bienvenido</h3>
							<br />
						</div>
					</div>
					{/*<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<img src={require("../img/vector_ok.png")} />
							<br />
						</div>
					</div>*/}
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<h5>Tu información se ha guardado satisfactoriamente.</h5>
							<br />
						</div>
					</div>
					<div className="row">
						<div className="col" style={{"textAlign": "center"}}>
							<p>Recibirás un SMS con su código de cliente, el cual se te solicitará para utilizar<br />los servicios de Call Center. De ahora en adelante deberá acceder a su <br />sesión ingresando tu usuario y contraseña.</p>
						</div>
					</div>
					<div className="row">
						<div style={{"textAlign": "center"}}>
							<a onClick={this.enviarLogin} className="btn txt-orange">Iniciar Sesión</a>
						</div>
					</div>
				</div>
				<div className='modal fade in' style={{"display":"block"}} id='modal-bienvenida' tabIndex='-1' role='dialog' aria-labelledby='modal-bienvenida'>
					<div className="modal-backdrop fade in" style={{"zIndex":"0"}}></div>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title orange-text'>¡Bienvenido!</h4>
							</div>
							<div className='txt-black txt-center pd-15'>
								<p>Tu información se ha guardado satisfactoriamente.</p>
								<p>De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la aplicación Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.</p>
							</div>
							<div className='modal-footer'>
								<button type='button' onClick={this.enviarLogin} className='btn orange-btn' data-dismiss='modal'>Iniciar sesión</button>
							</div>
						</div>
					</div>
				</div>

				{this.state.isModalOpened &&
					<Modal closeModalFromChild={this.closeModalFromChild}>
						<div>
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
										<img src={require('../img/verified_user_success.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal">¡Bienvenido!</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
									<p className=" gnp-material-content-modal">De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la aplicación Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.enviarLogin} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>}	
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Bienvenido);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/bienvenido.cmpt.js